module.exports = __webpack_public_path__ + "static/media/Sarvesh_Mankar.11695c4c.jpg";